import { render, staticRenderFns } from "./DateTitle.vue?vue&type=template&id=65cf369b&scoped=true"
import script from "./DateTitle.vue?vue&type=script&lang=js"
export * from "./DateTitle.vue?vue&type=script&lang=js"
import style0 from "./DateTitle.vue?vue&type=style&index=0&id=65cf369b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf369b",
  null
  
)

export default component.exports